import { BasicConfig } from '@shared/models/basic-config.interface';

export abstract class AppConfig extends BasicConfig {
  privileges: {
    notification: {
      duplicates: string;
      inviteToApply: string;
      hiringManagerFlow: string;
      referralExtended: string;
    };
    job: {
      create: string;
      edit: string;
      notes: string;
      files: string;
      status: string;
      view: string;
      publish: string;
      teamMembers: {
        view: string;
        edit: string;
      };
    };
    candidates: {
      view: string;
      create: string;
      edit: string;
    };
    companies: {
      view: string;
      create: string;
      edit: string;
    };
    reports: {
      view: string;
      readAllTenants: string;
    };
    settings: {
      anonymization: string;
      user: string;
      profile: string;
    };
    jobBoards: {
      viewPage: string;
    };
    talentPools: {
      view: string;
      create: string;
    };
    tasks: {
      view: string;
    };
  };
}

export type AppPrivileges = AppConfig['privileges'];
